import { publish } from '../../utils/pubsub'
import Router from 'next/router'

export function handleErrorsLogin (e, sessionStore) {
  const systemDownMessage = 'The system is currently down. Please try again later.'
  let error
  if (e.message) {
    const newError = JSON.parse(e.message)
    if (newError.status === 401) {
      if (newError.data.status === 'invalid_grant') {
        error = new Error('You have entered an invalid email or password.')
      } else {
        error = new Error(' The account you are trying to login is inactive. Please contact your system administrator')
      }
    } else if (newError.status === 500) {
      error = new Error('The tenant does not exist. Please contact your system administrator')
    } else if (newError.status === 504) {
      error = new Error(systemDownMessage)
    } else {
      error = newError
    }
  } else if (e.response.status === 401) {
    error = new Error('You have entered an invalid email or password.')
  } else if (e.response.status === 500) {
    error = new Error(systemDownMessage)
  } else if (e.response.status === 400) {
    error = new Error(systemDownMessage)
  } else {
    error = e
  }
  sessionStore.setLastError(error)
  sessionStore.isLoading = false
}

export function handleErrorsAPI (e, sessionStore = null, env = null) {
  const toastrDanger = 'toastr.danger'

  if (e.status === 409) {
    publish(toastrDanger, e.data.message)
  } else if (e.status === 400) {
    if (typeof e.data.data === 'string') {
      publish(toastrDanger, e.data.data)
    } else if (typeof e.data.message === 'string') {
      publish(toastrDanger, e.data.message)
    } else {
      e.data.data.map(i => {
        publish(toastrDanger, `${i.position.replace('.', '').toUpperCase()} ${i.message}`)
      })
    }
  } else if (e.status === 500 && e.data.message.match(/Authorisation with HMRC has failed/gi)) {
    const authMessage = 'Authorisation with HMRC has failed/expired.' +
                        'Please authorise Business Tax Portal with HMRC using the appropriate HMRC account for the tax registrations ' +
                        'setup within Business Tax Portal before trying again.' +
                        'You will be automatically redirected to the authorisation page in 10 seconds.'

    sessionStore.removeHmrcAuth(env)
    publish(toastrDanger, {
      message: authMessage,
      options: {
        showAnimation: 'animated fadeIn',
        hideAnimation: 'animated fadeOut',
        timeOut: 0,
        extendedTimeOut: 0,
        style: {
          width: '500px'
        }
      }
    })
    setTimeout(() => {
      Router.push('/submission-gateway/authorisation?status=failed')
    }, 10000)
  } else if (e.status === 500) {
    publish(toastrDanger, e.data.message)
  } else if (e.status === 504) {
    publish(toastrDanger, 'Network issue. Please try again later.')
  } else if (e.status === 404) {
    publish('toastr.warning', 'No records found')
  } else {
    publish(toastrDanger, 'An error occurred doing operation.')
  }
}
